var React = require("react");

var SiteHeader =          require("../controls/SiteHeader.jsx");
var Footer =              require("../controls/Footer.jsx");

const SECTION_NAME = "404";

class PageNotFound extends React.Component {
    
    constructor(){
        super();

        this.onSearch = this.onSearch.bind(this);
    }

    componentDidMount(){
        googleGA("send", "event", "page not found", "pageview");
        document.title = `Page not found | library.io`;
    }
    
    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }
    
    getInfo(){
        let title, description;
        let { history: { location: {search}} } = this.props;
        
        if(this.props.title && this.props.description){
            title = this.props.title;
            description = this.props.description;
        }
        else if(search.includes("forbidden")){
            title = "403: Forbidden";
            description = "You do not have permission to access this page.";

        }else{
            title =  "404: Page not found";
            description = "The page you requested was moved or does not exit.";

        }
        return {title, description}
    }

    render() {
        let {title, description} = this.getInfo();
        return  <div className="pageNotFound">
                    <SiteHeader type="Explore" onSearch={this.onSearch}/>
                    <h1 className="pageNotFound__title">{ title }</h1>
                    <p className="pageNotFound__description">{ description }</p>
                    <Footer type={SECTION_NAME}/>
                </div>
    }
}

module.exports = PageNotFound;
